
export function UsdtToText(n) {
    return (n / 1000000).toFixed(2);
}
